import { useMutation } from '@gogame/query';

import { exportCategories } from '../../sources/categories';
import { exportCategories as exportCategoriesKey } from '../queryKeyFactory';

export const useExportCategories = () => {
  const exportMutation = useMutation(exportCategoriesKey(), exportCategories, {
    refresh: false,
  });

  return [exportMutation.mutateAsync, exportMutation];
};
